export const formatNumber = (num: number) => {
  if (num < 0){
    return "0"
  }
  if (num >= 1e6) {
    // For millions, truncate to two decimal places
    const millions = Math.floor((num / 1e6) * 100) / 100;
    return millions + 'M';
  } else if (num >= 1e3) {
    // For thousands, truncate to one decimal place
    const thousands = Math.floor((num / 1e3) * 10) / 10;
    return thousands + 'k';
  } else {
    return num.toString()
  }
};
